import { useBehavior, useButton, useTriggerAction } from '@libs/hooks';
import { TWidgetProps } from '@libs/types';
import { type TCoreButtonViewProps } from '@core/widgets';
import React from 'react';
import { TButtonBannerData } from '../../types/data';
import { TButtonOption } from '../../types/options';
import { ButtonBannerView } from './ButtonBannerView';

export const ButtonBanner = ({ widget }: TWidgetProps<TButtonBannerData, TButtonOption>) => {
    const { isHidden, isDisabled } = useBehavior(widget);
    const { triggerActionsByType, triggerActionsByNameAndType } = useTriggerAction(widget);
    const { handleClick } = useButton(widget, { isDisabled, triggerActionsByType, triggerActionsByNameAndType });

    const label = widget.data?.messages?.label;
    const hasNotification = widget.data?.hasNotification ?? true;
    const parentStyleNames = [widget.options?.style].filter(Boolean) as string[];

    return (
        <ButtonBannerView
            uid={widget.uid}
            widget={widget as TCoreButtonViewProps['widget']}
            label={label}
            hasNotification={hasNotification}
            margin={widget.options?.margin}
            isDisabled={isDisabled}
            isHide={isHidden}
            parentStyleNames={parentStyleNames}
            onClick={() => handleClick()}
        />
    );
};
